export const RATIO = 0.88;
